<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'htab',
})
</script>
<template>
    <div v-if="data" >
      <contenttitle :data="data" ></contenttitle>

      <a-tabs v-model:activeKey="activeKey" :style="{color:data.color}">
        <a-tab-pane v-for="(it,i) in data.child" :key="i">
          <template #tab>

            <h4 ><img style="vertical-align: middle" class="box-sm" :src="addip(it.icon)" v-if="it.icon" > {{ it.name }}</h4>
          </template>
          <a-row :gutter="[30,30]">
            <a-col :md="12" :sm="24" class="padding-lg">
                  <h3>{{ it.name }}</h3>
                  <h4 style="opacity: .8;" v-if="it.sub">{{ it.sub }}</h4>
                  <div style="opacity: .7;" class="margin-tb" v-if="it.contents" v-html="it.contents"></div>
            </a-col>
            <a-col :md="12" :sm="24" class="padding-lg">
              <a-row :gutter="[30,30]">
                <a-col  :sm="{span:8}" :md="{span:6}"  :lg="getCol.lg(data.col)"  v-for="(item,i) in it.child" :key="i">
                    <a class="content-box text-center"  :href="item.url" >
                      <img :src="addip(item.pic)" :alt="item.name" class="box-xxl round margin-bottom box-shadow" />
                      <h5>{{ item.name }}</h5>
                    </a>
                </a-col>
              </a-row>
            </a-col>
          </a-row>

        </a-tab-pane>

      </a-tabs>

    </div>
</template>
<script setup lang="ts" name="htab">
import {defineComponent,defineProps,ref } from 'vue'
import {addip,getCol} from '@/utils/util'
defineProps({
  data:Object
})
const activeKey=ref<Number>(0)
</script>
<style lang="less">
  .htab{
    .ant-tabs{color:inherit;}
  }
</style>
